import assignOffsetPagination from "@/schemas/assignOffsetPagination";
import InstagramPostSchema from "@apps/instagram/schemas/InstagramPostSchema";

const InstagramPostsResponseSchema =
    assignOffsetPagination(InstagramPostSchema);

export default InstagramPostsResponseSchema;
